import { DynamicSection, SectionTypes } from '@fiverr-private/ai_brief';
import { Gql } from '@fiverr-private/dynamic_matching';
import { BriefClassificationResponse } from '../../../api';
import { appTranslate } from '../../../i18n';
import { BudgetEditComponent, BudgetTitleComponent, BudgetViewComponent } from './BudgetSection';

export * from './BudgetSection';

export const getBudgetSection = (briefClassification: BriefClassificationResponse): DynamicSection => {
    const extractedBudgetInCents = briefClassification.resolved_data?.budget?.max_price_in_cents || 0;
    const extractedPricingType =
        briefClassification.resolved_data?.budget?.pricing_type?.toLowerCase() ===
        Gql.BriefPricingType.Hourly.toLowerCase()
            ? Gql.BriefPricingType.Hourly
            : Gql.BriefPricingType.Fixed;

    return {
        id: 'budget',
        mandatory: true,
        title: appTranslate('sections.budget.title').toString(),
        content:
            extractedBudgetInCents > 0
                ? {
                      budgetInCents: extractedBudgetInCents > 0 ? extractedBudgetInCents : null,
                      pricingType: extractedPricingType,
                  }
                : null,
        included: true,
        type: SectionTypes.dynamic,
        hideActions: true,
        TitleComponent: BudgetTitleComponent,
        ViewComponent: BudgetViewComponent,
        EditComponent: BudgetEditComponent,
    };
};
